import { render, staticRenderFns } from "./FaceSuccess.vue?vue&type=template&id=629e94e4&scoped=true&"
import script from "./FaceSuccess.vue?vue&type=script&lang=ts&"
export * from "./FaceSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./FaceSuccess.vue?vue&type=style&index=0&id=629e94e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e94e4",
  null
  
)

export default component.exports